module.exports = __webpack_public_path__ + "static/media/parts_28.09f2c655.svg";